import { fetcher } from '@commenda/utils';

import { GenerateErrorReportResponse } from './types';

export async function generateErrorReport(
  jobId: string,
  corporationId: number
): Promise<{
  success: boolean;
  data?: { data: GenerateErrorReportResponse };
  error?: string;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/jobs/${jobId}/error-report?corporation_id=${corporationId}`,
      {
        method: 'POST',
      },
      undefined
    );

    const data = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: data.message || 'Failed to generate error report',
      };
    }

    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unexpected error occurred',
    };
  }
}
